
import React, { useEffect, useState, useMemo } from 'react';
import { getdata, TIMEDATA, DAILYAVAILABLETIME, CLOSEDDATA, updatedata,formatdate, getdate, deletedata } from "../../util/global";
import DashboardTableBill from './DashboardTableBill';
import DashboardTableItem from "./DashboardTableItem";


const KitstersDashboard = () => {
  const [billdata, setbilldata] = useState([]);
  const [itemdata, setitemdata] = useState([]);

  const [showmodal, setshowmodal] = useState(false);
  const [formdata, setformdata] = useState({phonenumber:"", name:"", _id: null});

  const fetchdata = async () => {
    try {
      setbilldata((await getdata({"zohodatatype":"bills"}, "/zohodata" )).data);
      setitemdata([]);
      console.log("fetchdata " + billdata.length);
    } catch (err) { console.error(err); }
  };


  const openedit = (item) => {
    setformdata({ name: item.name, phonenumber: item.phonenumber, _id: item._id});
    setshowmodal("showwhatsappform");
  };

  const opensend = (item) => {
    setformdata({ name: item.name, phonenumber: item.phonenumber, _id: item._id});
    setshowmodal("showsendmessageform");
  };

  const openwebhook = (item) => {
    setformdata({ name: item.name, phonenumber: item.phonenumber, _id: item._id, webhookmessage:item.webhookmessage});
    //setformdata(item);
    setshowmodal("showwebhookform");
  };

  const openpaymentform = () => {
    setformdata({});
    setshowmodal("showpaymentform");
  };

  const handlesubmit = async () => {
    let payload = {data:{...formdata, datatype:"phonenumberdata", datetime:formdata.date+"T"+formdata.time}};
    if (!payload._id) {
      payload.status = "linking pending";
    }
    console.log(payload);
    debugger;
    
    const result = await updatedata(payload, "/updatephonenumber");
    setshowmodal(false);
    fetchdata();
  };

  const deletephonenumber = (item) => {
    console.log("delete item", item);
    if(!confirm("Are you sure?")) return false;
    deletedata({filter:{datatype:"phonenumberdata", _id:item._id}}, () => {fetchdata(); });
  };

  useEffect(() => { fetchdata(); }, []);
  

  return (
    <div className="content-area">
      <b>Bill (check: has attachment)</b>
      <DashboardTableBill 
        billdata={billdata}  
        />
      <b>Item (check: name should mention unit of measurement)</b>
      <DashboardTableItem 
        itemdata={itemdata}  
        />

      
    </div>
  );
};

export default KitstersDashboard;